/** Öffentliche Werte aus Netlify (VITE_ ist im Browser sichtbar, deshalb nie ein geheimer Schlüssel). */
export const supabaseUrl: string = import.meta.env.VITE_SUPABASE_URL ?? "";
export const supabaseAnonKey: string = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";

/** In Deploy Previews gibt es keine Datenbank (ADR-005). */
export const datenbankDa: boolean = supabaseUrl !== "" && supabaseAnonKey !== "";
